import React from 'react';
import styles from './Comments.scss';
import { t } from 'i18next';
import { useQuery } from '@apollo/client';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { WorkOrderComments } from 'domains-work-order-comments-web';
import { getMyMessagingTokenQuery } from 'graphql-queries';
import { convertToUUID } from 'uuid-encoding';

type Props = {
  serviceRequestId: string;
  testId?: string;
};

export function CommentsTab({ serviceRequestId }: Props) {
  const { data } = useQuery(getMyMessagingTokenQuery);

  const messagingToken = data?.me?.user?.messagingToken;
  const userId = data?.me?.user?._id;
  const userName = data?.me?.user?.name;

  return (
    <div className={styles.commentsTab}>
      {!messagingToken && <div>Loading chat...</div>}
      {messagingToken && (
        <WorkOrderComments
          channelId={convertToUUID(serviceRequestId)}
          chatTitle={t('web.admin.workOrder.serviceRequest.tenantChat.title')}
          messagingToken={messagingToken}
          user={{ id: convertToUUID(userId), name: userName }}
        />
      )}
    </div>
  );
}
